"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCV = function FlagCV(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "156.36",
    width: "409.6",
    height: "18.83",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "194.04",
    width: "409.6",
    height: "18.83",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "175.2",
    width: "409.6",
    height: "18.83",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-57.28-4.89l2.17,6.5,6.84,0a.55.55,0,0,1,.32,1l-5.5,4.07,2.06,6.53a.55.55,0,0,1-.84.61l-5.58-4-5.57,4a.55.55,0,0,1-.84-.61l2.06-6.53-5.5-4.07a.55.55,0,0,1,.32-1l6.84,0,2.17-6.5a.56.56,0,0,1,1,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-57.28,109.24l2.17,6.49,6.84.06a.55.55,0,0,1,.32,1l-5.5,4.07,2.06,6.53a.55.55,0,0,1-.84.61l-5.58-4-5.57,4a.55.55,0,0,1-.84-.61l2.06-6.53-5.5-4.07a.55.55,0,0,1,.32-1l6.84-.06,2.17-6.49a.55.55,0,0,1,1,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-94.33,115.61l5.51-4.07,5.63,3.89a.55.55,0,0,0,.84-.63l-2.17-6.49,5.44-4.15a.56.56,0,0,0-.34-1l-6.85.06-2.27-6.46a.55.55,0,0,0-1,0l-2.07,6.53-6.84.16a.55.55,0,0,0-.31,1l5.58,4-2,6.56a.55.55,0,0,0,.85.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-83.32,22.84l-5.59-4-5.55,4a.55.55,0,0,1-.85-.61l2-6.54-5.53-4a.55.55,0,0,1,.32-1l6.84-.09,2.14-6.51a.55.55,0,0,1,1,0l2.2,6.48,6.85,0a.55.55,0,0,1,.32,1l-5.48,4.09,2.1,6.52a.56.56,0,0,1-.85.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-31.76,22.92l5.51-4.07,5.63,3.89a.55.55,0,0,0,.83-.63l-2.16-6.49,5.44-4.16a.55.55,0,0,0-.34-1l-6.85.06L-26,4.07a.55.55,0,0,0-1.05,0l-2.05,6.53-6.85.16a.55.55,0,0,0-.31,1l5.57,4-1.95,6.56a.55.55,0,0,0,.85.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.75,115.53l-5.59-4-5.55,4a.55.55,0,0,1-.85-.62l2-6.53-5.52-4a.55.55,0,0,1,.32-1l6.84-.09,2.13-6.5a.55.55,0,0,1,1.05,0l2.2,6.49h6.85a.55.55,0,0,1,.32,1L-22,108.39l2.1,6.52a.56.56,0,0,1-.85.62Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-102.52,75.64l-6.84,0-2.26-6.47a.55.55,0,0,0-1,0l-2.07,6.53-6.85.14a.56.56,0,0,0-.31,1l5.57,4-2,6.56a.55.55,0,0,0,.86.6l5.51-4.06,5.62,3.9a.55.55,0,0,0,.84-.63l-2.16-6.49,5.45-4.15a.55.55,0,0,0-.34-1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.58,40.45l6.84-.13,2.09-6.52a.56.56,0,0,1,1.05,0l2.24,6.48,6.85,0a.55.55,0,0,1,.33,1l-5.46,4.13,2.14,6.5a.55.55,0,0,1-.84.63L-112,48.57l-5.52,4a.55.55,0,0,1-.86-.6l2-6.55-5.56-4a.56.56,0,0,1,.32-1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6,40.2l-6.85,0-2.26-6.47a.55.55,0,0,0-1,0l-2.08,6.52-6.84.16a.55.55,0,0,0-.31,1l5.56,4-2,6.56a.55.55,0,0,0,.85.6l5.51-4.06,5.63,3.9A.55.55,0,0,0,3,51.84L.85,45.34,6.3,41.2a.56.56,0,0,0-.34-1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.11,75.89l6.84-.12,2.1-6.52a.55.55,0,0,1,1,0L-.89,75.7l6.85,0a.55.55,0,0,1,.34,1L.84,80.8,3,87.3a.55.55,0,0,1-.84.63L-3.48,84l-5.52,4a.55.55,0,0,1-.86-.6l2-6.55-5.55-4a.55.55,0,0,1,.31-1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCV;
exports["default"] = _default;